
export const actionOptions = {
 // THIS IS ONLY FOR TESTING PURPOSES INSIDE THE COMPONENT, NOT MEANT TO INDICATE WHAT SHOULD BE USED IN PRODUCTION
 // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  // ACTIONS WILL BE HANDLED ON A PER-TABLE BASIS BY PORTAL DEVELOPERS
  "true": [
    {
      title: "Deactivate",
      cls: "deactivate-webhook",
      icon: "toggle-off",
      disabled: false
    },
    {
      title: "Test Connection",
      cls: "test-connection-webhook",
      icon: "wrench",
      disabled: false
    }
  ],
  "false": [
    {
      title: "Activate",
      cls: "activate-webhook",
      icon: "toggle-on",
      disabled: false
    }
  ],
};



// WEBPACK FOOTER //
// ./src/pages/webhooks/filter/actionOptions.js